module.exports = __webpack_public_path__ + "media/application/images/svgs/chevron-down-c151ca378d3a8b3b558c55e499114e4a.svg";